export enum NavId {
  analytics = 'analytics',
  dashboardBuilder = 'dashboardBuilder',
  intake = 'intake',
  intakeAllRequests = 'intakeAllRequests',
  intakeNewRequest = 'intakeNewRequest',
  intakeNewChatRequest = 'intakeNewChatRequest',
  intakeQuoteUpload = 'intakeQuoteUpload',
  knowledgeGraph = 'knowledgeGraph',
  cmdi = 'cmdi',
  company = 'company',
  demo = 'demo',
  superset = 'superset',
  dataFoundation = 'dataFoundation',
  dataFoundationIntegrationHub = 'dataFoundationIntegrationHub',
  dataFoundationEnrichmentHub = 'dataFoundationEnrichmentHub',
  dataFoundationExplorer = 'dataFoundationExplorer',
  demand = 'demand',
  demandAdd = 'demandAdd',
  demandCreate = 'demandCreate',
  demandIntakeCreate = 'demandIntakeCreate',
  demandDemands = 'demandDemands',
  demandNegotiationCases = 'demandNegotiationCases',
  contractDemand = 'contractDemand',
  contractDemands = 'contractDemands',
  contractDemandAdd = 'contractDemandAdd',
  coverageAssistant = 'coverageAssistant',
  negotiation = 'negotiation',
  notifications = 'notifications',
  search = 'search',
  riskSustainability = 'riskSustainability',
  riskSustainabilityOverview = 'riskSustainabilityOverview',
  team = 'team',
  teamManagement = 'teamManagement',
  teamAvailabilities = 'teamAvailabilities',
  teamLinkedDashboards = 'teamLinkedDashboards',
  teamManageDashboardLinks = 'teamManageDashboardLinks',
  userProfile = 'userProfile',
  settings = 'settings',
  settingsRuleAdd = 'settingsRuleAdd',
  settingsAllRules = 'settingsAllRules',
  settingsRuleCreate = 'settingsRuleCreate',
  settingsProcurementKnowledge = 'settingsProcurementKnowledge',
  rule = 'rule',
  internalTools = 'internalTools',
  cockpit = 'cockpit',
}
